import { Mail, Phone, MapPin } from "lucide-react";
import Hero from "../components/Hero";
import { motion } from "framer-motion";
import Swal from "sweetalert2";

export default function Contact() {

const handleSubmit = (e) => {
  e.preventDefault();
  Swal.fire({
    icon: "success",
    title: "Message Sent ✨",
    text: "Thanks for reaching out! We'll get back to you shortly.",
    confirmButtonColor: "#809080",
  });
};

  return (
    <div>
      <Hero
        title="We'd love to hear from you"
        description="Have a question, feedback, or just want to say hello? The SuprSkin team is here for you."
        image="https://img.freepik.com/premium-photo/vintage-phone-color-background_96727-2179.jpg?w=996"
      />

      <section className="bg-[#fef8f5] py-20 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16">
         
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <h2 className="text-3xl font-serif text-[#7a6e5f] font-bold">
              Let’s Connect
            </h2>
            <p className="text-[#7a6e5f]">
              Whether you're looking for personalised skincare advice or have a question about your order, we’re always happy to help. Drop us a message and we’ll get back to you soon!
            </p>

            <div className="space-y-6 text-[#7a6e5f]">
              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 mt-1" />
                <div>
                  <h4 className="font-semibold">Address</h4>
                  <p>123 Glow Lane, Bali 80227</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 mt-1" />
                <div>
                  <h4 className="font-semibold">Phone</h4>
                  <p>+62 812-3456-7890</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 mt-1" />
                <div>
                  <h4 className="font-semibold">Email</h4>
                  <p>hello@suprskin.com</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.form
  onSubmit={handleSubmit}
  initial={{ opacity: 0, y: 30 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
  viewport={{ once: true }}
  className="bg-white p-8 rounded-xl shadow space-y-6"
>
            <div>
              <label className="block text-sm font-medium text-[#7a6e5f] mb-2">
                Name
              </label>
              <input
                type="text"
                className="w-full px-4 py-2 border border-[#d6a89e] rounded-md focus:ring-2 focus:ring-[#809080] focus:outline-none"
                placeholder="Your name"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-[#7a6e5f] mb-2">
                Email
              </label>
              <input
                type="email"
                className="w-full px-4 py-2 border border-[#d6a89e] rounded-md focus:ring-2 focus:ring-[#809080] focus:outline-none"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-[#7a6e5f] mb-2">
                Message
              </label>
              <textarea
                rows="4"
                className="w-full px-4 py-2 border border-[#d6a89e] rounded-md focus:ring-2 focus:ring-[#809080] focus:outline-none"
                placeholder="Your message"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-[#809080] text-white py-3 rounded-md hover:bg-[#6e806e] transition-colors"
            >
              Send Message
            </button>
          </motion.form>
        </div>
      </section>
    </div>
  );
}
